import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { accessRows, accessChecks } from '../../data/instantAccess';
export function InstantAccess() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-137" data-mp="39dq55tozbejc">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-138" data-mp="34bsiephde1ln">
        <SectionTag icon="📦" data-id="element-139" data-mp="30ayu3v00mks8">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-140" data-mp="30cjp1lq8s5qm">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-141" data-mp="2qm75nwu5yim2">
          Material profesional descargable al instante, sin esperar envíos.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-142" data-mp="2gnhjhrv8ic00">
        <ScrollHintTable minWidth="420px" data-id="element-143" data-mp="2gp2dngdmzsxc">
          <table className="w-full text-left text-sm" data-id="element-144" data-mp="2cle9l7o7rfgu">
            <thead data-id="element-145" data-mp="2co0fz3zdboxh">
              <tr className="border-b border-slate-200 bg-bg-secondary text-xs uppercase tracking-wide text-muted" data-id="element-146" data-mp="35oyfvxgrcp3z">
                <th className="px-5 py-3 font-bold" data-id="element-147" data-mp="3afol9ap6oryo">Formato</th>
                <th className="px-5 py-3 font-bold" data-id="element-148" data-mp="2vqir4157drxn">Contenido</th>
                <th className="px-5 py-3 font-bold" data-id="element-149" data-mp="2vs3ijhw80ura">Páginas</th>
              </tr>
            </thead>
            <tbody className="bg-bg-primary" data-id="element-150" data-mp="30pvcehgfeqy4">
              {accessRows.map((row, i) => <tr key={row.content} className={i !== accessRows.length - 1 ? 'border-b border-slate-100' : ''} data-id="element-151" data-mp="3ofpmir9d21eo" data-mpi={i}>
                  <td className="whitespace-nowrap px-5 py-4 text-ink" data-id="element-152" data-mp="3tc6nwn5kmc9p">{row.format}</td>
                  <td className="px-5 py-4 text-muted" data-id="element-153" data-mp="3fdyn245eyqt9">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-flash" data-id="element-154" data-mp="3jf1zego964pq">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-155" data-mp="281zgheyol32e">
          {accessChecks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-ink" data-id="element-156" data-mp="eho5x64mvl6y">
              <CheckIcon size={16} className="text-success" data-id="element-157" data-mp="9kfkmwo6v11h" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}